export default __webpack_public_path__ + "static/media/notesAPP.1b079172.jpg";